import { userHasRight } from "../../../framework";
import { toolTip } from "../../controls/toolTip";
import { alert } from "../../core/alert";
import { ll } from "../../core/ll";
import { buildDataBindSyntax } from "../buildDataBindSyntax";
import K_Input from "../templates/K_Input";
import { ComponentOptions, RightLockable } from "./component";
import { InputOptions } from "./input";
import { TemplateComponent } from "./templateComponent";
import _ from "lodash";

export interface TextBoxOptions extends InputOptions {
    bindNumberValue?: string;
    inputType?: "password";
    min?: number;
    useLink?: boolean | "true";
    linkedTo?: string;
    linkedToBind?: string;
    linkedClasses?: string;
    maxLength?: number | string;
    searchType?: string | any;
    removeInvalidChars?: boolean;
    readOnly?: boolean;
    showIcon?: boolean;
    labelField?: string;
    bindClass?: string;
    valueField?: string;
    bindId?: string;
    bindObject?: string;
    placeholder?: string;
    width?: number;
    containsSearch?: boolean | "true";
    Required?: boolean | "true";
    decimals?: number;
    format?: string;
    woopField?: boolean;
    pattern?: string;
    requiredRight?: string;
    showRequiredNextToLabel? : boolean;
}

export class TextBox extends TemplateComponent {

    options: TextBoxOptions & RightLockable;

    constructor(options: TextBoxOptions) {
        super(K_Input, options);
    }

    preRender() {
        const options = this.options;

        // Set defaults for woop fields
        if (options.labelAbove) {
            options.bsc = options.bsc || " ";
            if (options.valueWidth) {
                options.containerWidth = options.containerWidth || +options.valueWidth + 10;
                options.labelWidth = options.labelWidth || options.valueWidth;
            }
            options.labelAbove = buildDataBindSyntax(options.labelAbove, "text");
        }

        options.label = buildDataBindSyntax(options.label, "text");
        options.bindNumberValue = buildDataBindSyntax(options.bindNumberValue, "text");
        options.bindValue = buildDataBindSyntax(options.bindValue, "input");
        options.containerClasses = options.containerClasses || "";
        options.containerBind = buildDataBindSyntax(options.containerBind, "container");
        options.bsc = options.bsc || "col-lg-3 col-md-4 col-xs-6";
        options.labelBsc = options.labelBsc || "col-xs-5";
        options.inputBsc = options.inputBsc || "col-xs-7  no-pad";
        options.iconType = options.iconType || "";
        options.iconId = options.iconId || "";
        options.iconClasses = options.iconClasses || "";
        options.iconInput = options.iconType ? "icon-input" : "";
        options.useLink = options.useLink || null;
        options.linkedTo = options.linkedTo || null;
        options.linkedToBind = options.linkedToBind || null;
        options.removeInvalidChars = options.removeInvalidChars || false;
        options.showRequiredNextToLabel = options.showRequiredNextToLabel || false;
        /* If showRequiredNextToLabel is true, but there is no label to display above the text box, this value should be set to false instead to
         * ensure that any required indicators still display correctly next to the text box itself */
        if (!(options.labelAbove || options.hcLabelAbove) && options.showRequiredNextToLabel) {
            options.showRequiredNextToLabel = false;
        }

        if (options.requiredRight) {
            options.rightLocked = !userHasRight(options.requiredRight);

            if (options.rightLocked) {
                options.readOnly = true;
                options.iconType = undefined;
                options.iconId = undefined;
                options.iconClasses = undefined;
                options.classes += " right-locked";
                options.containerClasses += " right-locked";
            }
        }

        if (this.id.toString().indexOf("_UDF_") != -1) {
            options.maxLength = 2000;
        }
    }

    create() {
        if (this.options.infoTooltip || this.options.infoTooltipContent) {
            toolTip({
                alignX: "center",
                alignY: "top",
                alignTo: "target",
                offsetY: 5,
                selector: $(`#${this.id}_info`),
                content: this.options.infoTooltip ? ll(this.options.infoTooltip) : this.options.infoTooltipContent
            });
        }

        var component = this;
        var textBox = $("#" + this.id);

        if ((component.options.readonly || component.options.readOnly) && textBox) {
            textBox.readOnly(true);
        }

        if (component.options.showIcon) {
            $("#" + component.options.iconId).show();
        }

        if (component.options.useLink && component.options.linkedTo && component.options.linkedToBind) {
            var sourceControl = $("#" + component.options.zScreen.id + "_" + component.options.linkedTo);
            var linkControl = $("#" + component.id + "_linked");

            linkControl.tie("change", function () {
                var linked = $(this).prop("checked");
                var parentComponent = $("#" + component.id);

                if (linked) {
                    parentComponent.readOnly(true);
                    linkControl.prop("required", true);

                    sourceControl.tie("change.linkedControl", function () {
                        let newVal = sourceControl.val();
                        if (component.options.maxLength) {
                            const maxLength = _.parseInt(_.toString(component.options.maxLength), 10);
                            newVal = _.truncate(newVal, { length: maxLength, omission: "" })
                        }
                        parentComponent.val(newVal);
                        parentComponent.change();
                    });

                    sourceControl.change();
                } else {
                    parentComponent.readOnly(false);
                    linkControl.prop("required", false);
                    sourceControl.off("change.linkedControl");
                }
            });
            linkControl.data("parentComponent", component);
        }

        var valueCaught = "";

        textBox.on("change", function (e) {
            valueCaught = textBox.val();

            if (valueCaught.trim().length == 0) {
                textBox.val("");
            }
        });

        if (component.options.removeInvalidChars) {
            var isValidChar = function (code) {
                if ($.type(code) !== "number") {
                    return false;
                }

                if ((code >= 97 && code <= 122) // a-z
                    || (code >= 65 && code <= 90) // A-Z
                    || (code >= 48 && code <= 57) // 0-9
                    || code == 32 // space
                    || code == 95 // _
                ) {
                    return true;
                }

                return false;
            };

            textBox.keypress(function (event) {
                if (!isValidChar(event.charCode)) {
                    event.preventDefault();
                    alert({
                        header: ll("InvalidCharEntered"),
                        message: ll("InvalidCharEnteredMessage").format(textBox.closest(".row").find(".bind-label").text()),
                        type: "warning",
                        id: "InvalidCharWarning"
                    });
                }
            });

            textBox.bind("paste", function (e) {
                var pasted = (e.originalEvent as any).clipboardData.getData("text");

                for (var i = 0; i < pasted.length; i++) {
                    var code = pasted.charCodeAt(i);
                    if (!isValidChar(code)) {
                        e.preventDefault();

                        alert({
                            header: ll("InvalidCharPasted"),
                            message: ll("InvalidCharPastedMessage").format(textBox.closest(".row").find(".bind-label").text()),
                            type: "warning"
                        });

                        break;
                    }
                }
            });
        }
    }

}
